export enum PageType {
  CONTENT = 'CONTENT',
  QUIZ = 'QUIZ',
  WEBINAR = 'WEBINAR',
  ADVERTISEMENT = 'ADVERTISEMENT'
}

export enum MediaType {
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO'
}

export enum UserRoleByProduct {
  VIEWER = 'VIEWER',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  CONTENT_EDITOR = 'CONTENT_EDITOR'
}

export enum ModuleType {
  FREE = 'FREE',
  EXTRA = 'EXTRA',
  DEFAULT = 'DEFAULT',
  EXTRA_PAID = 'EXTRA_PAID'
}
